module.exports = __webpack_public_path__ + "img/pay-box-inactive-dark.271932dd.svg";